import React from "react";
import { formatName } from '../../utils/spaUtils';

const PaymentItemCard = (props) => {
    let { item, ShipboardCurrencyCode, daysToCruise } = props;

    let appointment = processReservation(item);

    let imageUrl = `${process.env.imageUrl}/${appointment.spaId}.jpg`;
    let row = (
        <li className='spa-res-item' >
            <div data-test-id="reservation-table" className="spa-res-item-wrapper row gotham-xn-medium" key={props.item.treatmentId} value={item.buttonText}>

                <div className="spa-res-item-img col-xs-12 col-md-2 img-responsive-wrapper">
                    <img alt='' src={imageUrl} onError={(e) => { e.target.onerror = null; e.target.src = `/images/global/personalizer/image-not-available-640.jpg` }} />
                </div>

                <div className="spa-res-item-content col-xs-12 col-md-6 col-xs-pad-0 col-md-pad-15">
                    <h3 className="spa-res-item-title gotham-xn-medium font-size-p5" data-test-id="service-name">
                        <button style={daysToCruise <= 3 ? { cursor: 'not-allowed' } : {}} disabled={daysToCruise <= 3} className='button-link gotham-xn-book' onClick={() => props.openDetailsPage(appointment.spaId)}>{appointment.treatmentName}</button>
                    </h3>
                    <div className="row spa-res-item-content-row-2 bottom-spacing-5">
                        <div className="col-xs-6 col-sm-5 col-xs-pad-0 spa-land-datetime">{item.serviceGroup === 'relaxationareas' ? 'All-Day' : item.formattedTime} | {appointment.date}</div>
                        <div className="col-xs-6 col-sm-7 col-xs-pad-0" data-test-id="guest-name">{appointment.fullName}</div>
                    </div>
                    <div className="row spa-res-item-content-row-3">
                        <div className="col-xs-6 col-sm-5 col-xs-pad-0">{`Price:${ShipboardCurrencyCode === 'USD' ? '$' : 'AU$'} ${appointment.price}`}</div>
                        <div className="col-xs-6 col-sm-7 col-xs-pad-0  red" data-test-id="payment-required" >Payment Required</div>
                    </div>
                </div>

                <div className="spa-res-item-btn col-xs-12 col-md-4 font-size-p1" data-test-id="reservation-confirmed">
                    <button className=" gotham-xn-medium spa-landing-cancel-id tertiary-btn red" data-test-id="unpaid-cancel" onClick={props.handleShowCancelPopup} aria-label={`Cancel - ${appointment.treatmentName} for  ${appointment.fullName} from cart`}>
                        <svg focusable="false" className="svg-icon svg-icon-close-x reserved-cancel-icon"> <use xlinkHref="#icon-close-x" ></use></svg>
                        Cancel
					</button>
                </div>

            </div>
        </li>);
    return (row)
};

const processReservation = (appointment) => {
    let _appointment = {};
    let { PassengerDetail } = appointment;
    let { Name } = PassengerDetail;
    _appointment.spaId = appointment.treatmentId;
    _appointment.fullName = formatName(`${Name.FirstName} ${Name.LastName}`);
    _appointment.time = appointment.formattedTime;
    _appointment.date = appointment.formatDate;
    _appointment.price = appointment.treatmentPrice;
    _appointment.paymentStatus = appointment.PaymentStatus;
    _appointment.treatmentName = appointment.treatmentDesc;
    return _appointment;
}


export default PaymentItemCard;
